import { Component, OnInit } from '@angular/core';

import { AngularFireAuth } from 'angularfire2/auth';

import { AdminAuthService } from '../admin-auth.service';
import { DBService } from '../db.service';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {
  private adminName;
  showAdminMenu = false;
  links = [
    {
      title: 'Dashboard',
      icon:  'icon-menu-dashboard.png',
      path: 'dashboard'
    },
    {
      title: 'Forums',
      icon:  'icon-menu-forum.png',
      path: 'forums'
    },
    {
      title: 'Companies',
      icon:  'icon-menu-members.png',
      path: 'companies'
    },
    {
      title: 'Vendors',
      icon:  'icon-menu-vendors.png',
      path: 'vendors'
    },
    /*{
      title: 'Users',
      icon:  'icon-menu-members.png',
      path: 'members'
    },
    {
      title: 'News Feed',
      icon:  'icon-menu-newsfeed.png',
      path: 'news-feed'
    },*/
    {
      title: 'Essential Service Providers',
      icon:  'icon-menu-essential.png',
      path: 'providers'
    },
    {
      title: 'Calendar',
      icon:  'icon-menu-calendar.png',
      path: 'calendar'
    },
    {
      title: 'Resources',
      icon:  'icon-menu-resources.png',
      path: 'resources'
    },
    {
      title: 'Newsletter',
      icon:  'icon-menu-newsletter.png',
      path: 'newsletters'
    },
    {
      title: 'Surveys',
      icon:  'icon-surveys.png',
      path: 'surveys'
    }
  ]

  constructor(
    private afAuth: AngularFireAuth,
    private authService: AdminAuthService,
    private dbService: DBService
  ) {
    this.afAuth.authState.subscribe( admin => {
      if (admin) {
        this.dbService.getMember(admin.uid).subscribe( user => {
          this.adminName = `${user.firstName} ${user.lastName}`;
        });
      }
    });
  }

  ngOnInit() {
  }

  onAdminNameClicked() {
    this.showAdminMenu = !this.showAdminMenu;
  }

  logoutAdmin() {
    this.authService.logoutAdmin();
  }

}



// WEBPACK FOOTER //
// ./src/app/nav/nav.component.ts